const errorName = 'API error'

const handleJsonResponse = async (response: Response): Promise<any> => {
  let jsonResponse: any = ''

  if (response.json) {
    jsonResponse = await response.json()
  }

  if (response.ok) {
    return jsonResponse
  } else {
    const error = new Error(jsonResponse)
    error.name = errorName

    throw error
  }
}

export const http = {
  destroy: async (url: string) => {
    const response = await fetch(url, { method: 'DELETE' })

    return handleJsonResponse(response)
  },
  get: async <T = any>(url: string): Promise<T> => {
    const response = await fetch(url)

    return handleJsonResponse(response)
  },
  post: async (url: string, body: Record<string, any> = {}) => {
    const response = await fetch(url, {
      body: JSON.stringify(body),
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
    })

    return handleJsonResponse(response)
  },
  multiPartPost: async (url: string, body: FormData) => {
    const response = await fetch(url, {
      body,
      method: 'POST',
    })

    return handleJsonResponse(response)
  },
  patch: async (url: string, body: Record<string, any> = {}) => {
    const response = await fetch(url, {
      body: JSON.stringify(body),
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'PATCH',
    })

    return handleJsonResponse(response)
  },
}
